<!-- footer start-->
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 footer-copyright text-center">
            <p class="mb-0 fw-bold">SCM - Sistemas 1.0</p>
        </div>
    </div>
</div>